module.exports = __webpack_public_path__ + "img/sap.5f0deb9b.png";